<template>
  <div class="container">
    <div class="title">
      充电宝合作协议更新提示
    </div>
    <div class="content">
      感谢您信任并使用美团充电宝的产品和服务,鉴于您采用个人结算方式，为了更好地为您提供服务,现在双方已签署的《美团充电宝合作协议》基础上，需要您与我们的合作公司额外签订《服务协议》。后续将由该公司为您发放合作服务费用。
    </div>
    <div class="content">
      请您仔细阅读并充分理解服务内容并作出相应选择。
    </div>
    <div class="content">
      一旦您选择同意或继续使用我们的产品和服务时,即意味您同意服务协议内容。
    </div>
    <div class="agreement-box">
      <van-checkbox
        v-model="checked"
        :label-disabled="true"
        :icon-size="15"
        checked-color="#797979"
        class="centered-checkbox"
      >
        <span
          style="color: #8A0FFE;"
          @click="showAgreementContent"
        >《服务协议》</span>
      </van-checkbox>
      <div class="button-group">
        <van-button
          color="#B0B0B0"
          round
          class="equal-width-button"
          @click="show = true"
        >
          不同意
        </van-button>
        <van-button
          color="#1A1A1A"
          round
          :disabled="!checked"
          class="equal-width-button"
          @click="onConfirm"
        >
          已读并同意
        </van-button>
      </div>
    </div>
    <van-popup
      v-model="show"
      position="bottom"
      round
      :style="{ height: '30%' }"
    >
      <div class="disagree-popup">
        <div class="disagree-title">
          温馨提示
        </div>
        <div class="disagree-content">
          您的建议是美团充电宝不断前进的动力，请您阅读和确认服务协议内容，若您对服务协议内容有任何疑问可联系充电宝业务人员。
        </div>
        <van-button
          color="#B0B0B0"
          round
          class="disagree-button"
          @click="goback"
        >
          退出
        </van-button>
      </div>
    </van-popup>
    <Deposit
      ref="deposit"
    />
  </div>
</template>
<script>
import Checkbox from 'vant/lib/checkbox';
import Button from 'vant/lib/button';
import Popup from 'vant/lib/popup';
import Deposit from '@/views/home/Deposit';

import 'vant/lib/checkbox/style';
import 'vant/lib/button/style';
import 'vant/lib/popup/style';

export default {
  name: 'ServiceAgreement',
  components: {
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Popup.name]: Popup,
    Deposit,
  },
  data() {
    return {
      checked: true,
      show: false,
      signInfo: {},
    };
  },
  mounted() {
    const { signInfo } = this.$route.params || {};
    this.signInfo = signInfo;
  },
  methods: {
    showAgreementContent() {
      const pdfUrl = 'https://s3plus.meituan.net/cdb-m-default-bucket/%E3%80%8A%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE%E3%80%8B1763466346651.pdf';
      this.$router.push({ name: 'contractPdf', params: { pdfUrl } });
    },
    goback() {
      this.$router.go(-1);
    },
    onConfirm() {
      this.$refs.deposit.handleSignAndVerification({ ...this.signInfo, signed: true });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 50px 40px 0;
  text-align: left;
  .title {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 50px;
  }
  .content {
    margin-bottom: 20px;
  }
  .agreement-box {
    position: absolute;
    bottom: 60px;
    left: 0;
    right: 0;
    text-align: center;
  }
  .centered-checkbox {
    justify-content: center;
    margin-bottom: 60px;
  }
  .button-group {
    display: flex;
    justify-content: center;
    gap: 20px;
  }
  .equal-width-button {
    width: 40%;
  }
  .disagree-popup {
    padding: 20px;
    .disagree-title {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 20px;
      text-align: center;
    }
    .disagree-content {
      margin-bottom: 20px;
    }
    .disagree-button {
      position: absolute;
      bottom: 30px;
      left: 30%;
      right: 30%;
    }
  }
}
</style>
